import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Observable } from 'rxjs';

import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';
import { DaysDistribution, DaysDistributionFilters } from '../../../commons/models/days-distribution.model';

export type DaysDistributionsColumn = "date" | "user" | "days" | "actions";

@Component({
  selector: 'days-distribution-list',
  templateUrl: './days-distribution-list.component.html',
  styleUrls: ['./days-distribution-list.component.scss'],
})
export class DaysDistributionListComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input()
  daysDistributions: DaysDistribution[];

  @Input()
  defaultFilters: DaysDistributionFilters;

  pageSizeOptions = PAGE_SIZE_OPTIONS;
  expandedElement: DaysDistribution | null;

  @Input()
  total: Observable<number>;
  @Input()
  displayedColumns: DaysDistributionsColumn[] = ["date", "user", "days", "actions"];

  @Input()
  canAdd: boolean;
  @Input()
  canEdit: boolean;
  @Input()
  canSelect: boolean;

  @Output()
  onLoad: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
  @Output()
  onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output()
  onFilterChange: EventEmitter<DaysDistributionFilters> = new EventEmitter<DaysDistributionFilters>();

  @Output()
  onSelectDaysDistribution: EventEmitter<DaysDistribution> = new EventEmitter<DaysDistribution>();
  @Output()
  onAddDaysDistribution: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onEditDaysDistribution: EventEmitter<DaysDistribution> = new EventEmitter<DaysDistribution>();

  constructor() { }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort) => {
      this.onSortChange.emit(sort);
    });
    this.paginator.page.subscribe((pageEvent) => {
      this.onPageChange.emit(pageEvent);
    });
  }

  addDaysDistribution() {
    this.onAddDaysDistribution.emit();
  }

  editDaysDistribution(account: DaysDistribution) {
    this.onEditDaysDistribution.emit(account);
  }

  selectDaysDistribution(account: DaysDistribution) {
    this.onSelectDaysDistribution.emit(account);
  }

  onFilter(filters: DaysDistributionFilters) {
    this.paginator.firstPage();
    this.onFilterChange.emit(filters);
  }
}
